import {
    AUTH_ERROR,
    LOGIN_FAIL,
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_UNVERIFIED,
    LOGOUT,
    LOGOUT_FAILURE,
    LOGOUT_REQUEST,
    OTP_FAILURE,
    OTP_REQUEST,
    OTP_SUCCESS,
    PASSWORD_RESET_SUCCESS,
    PASSWORD_RESET_REQUEST,
    PASSWORD_RESET_FAILURE,
    REGISTER_FAIL,
    REGISTER_REQUEST,
    REGISTER_SUCCESS,
    RESEND_OTP_FAILURE,
    RESEND_OTP_REQUEST,
    RESEND_OTP_SUCCESS,
    USER_LOADED,
    VERIFY_OTP_FAILURE,
    VERIFY_OTP_REQUEST,
    VERIFY_OTP_SUCCESS,
} from '../actions/types';

const initialState = {
    token: localStorage.getItem('token'),
    isAuthenticated: false,
    loading: false,
    user: null,
    hasRegistered: false,
    isVerified: false,
    loginSuccess: false,
    profilePicture: '',
    profile: null,
    OTP: null,
    resentOTP: null
}

export default function auth(state = initialState, action) {
    const {type, payload} = action;

    switch (type) {

        case REGISTER_SUCCESS:
            return {
                ...state,
                isAuthenticated: false,
                loading: false,
                user: payload,
                hasRegistered: true
            }
            break;
        case LOGIN_SUCCESS:
            localStorage.setItem('token', payload.access_token.token);
            localStorage.setItem('user', JSON.stringify(payload.user));
            console.log("payload:", payload)
            return {
                ...state,
                isAuthenticated: true,
                loading: false,
                user: payload,
                isVerified: true,
                loginSuccess: true,
                profilePicture: payload.user.image
            }
            break;

        case LOGIN_UNVERIFIED:
            return {
                ...state,
                isAuthenticated: false,
                loading: false,
                user: payload,
                isVerified: false,
                loginSuccess: true
            }
            break;

        case OTP_REQUEST:
            return {
                ...state,
                otpRequest: true,
                otpSuccess: false,
                otpFailure: false
            }
            break;
        case OTP_SUCCESS:
            return {
                ...state,
                otpRequest: false,
                otpSuccess: true,
                otpFailure: false
            }
            break;
        case REGISTER_FAIL:
        case AUTH_ERROR:
        case LOGIN_FAIL:
        case LOGOUT_REQUEST:
            return {
                ...state,
                logoutRequest: true,
                logoutSuccess: false,
                logoutFailure: false
            }
            break;
        case LOGOUT:
            return {
                ...state,
                logoutRequest: false,
                logoutSuccess: true,
                logoutFailure: false,
                isAuthenticated: false
            }
            break;
        case LOGOUT_FAILURE:
            return {
                ...state,
                logoutRequest: false,
                logoutSuccess: false,
                logoutFailure: true
            }
            break;
        case OTP_FAILURE:
            localStorage.removeItem('token');
            return {
                ...state,
                otpRequest: false,
                otpSuccess: false,
                otpFailure: true
            }
            break;
        case LOGIN_REQUEST:
        case REGISTER_REQUEST:
            return {
                ...state,
                token: null,
                isAuthenticated: false,
                loading: true,
                logoutSuccess: false
            }
            break;
        case PASSWORD_RESET_REQUEST:
            return {
                ...state,
                resetPasswordRequest: true,
                resetPasswordSuccess: false,
                resetPasswordFailure: false,
            }
            break;
        case PASSWORD_RESET_SUCCESS:
            return {
                ...state,
                resetPasswordRequest: false,
                resetPasswordSuccess: true,
                resetPasswordFailure: false,
            }
            break;
        case PASSWORD_RESET_FAILURE:
            return {
                ...state,
                resetPasswordRequest: false,
                resetPasswordSuccess: false,
                resetPasswordFailure: true,
            }
            break;
        case VERIFY_OTP_REQUEST:
            return {
                ...state,
                verifyOTPRequest: true,
                verifyOTPSuccess: false,
                verifyOTPFailure: false,
            }
        case VERIFY_OTP_SUCCESS:
            return {
                ...state,
                isVerified: true,
                verifyOTPRequest: false,
                verifyOTPSuccess: true,
                verifyOTPFailure: false,
            }
            break;
        case  VERIFY_OTP_FAILURE:
            return {
                ...state,
                verifyOTPRequest: false,
                verifyOTPSuccess: false,
                verifyOTPFailure: true,
            }
            break;
        case USER_LOADED:
            localStorage.setItem('profile', JSON.stringify(payload.profile));
            return {
                ...state,
                isAuthenticated: true,
                loading: false,
                profile: payload.profile,
            }
        case RESEND_OTP_REQUEST:
            return {
                ...state,
                resendOTPRequest: true,
                resendOTPSuccess: false,
                resendOTPFailure: false
            }
        case RESEND_OTP_SUCCESS:
            return {
                ...state,
                resendOTPRequest: false,
                resendOTPSuccess: true,
                resendOTPFailure: false
            }
        case RESEND_OTP_FAILURE:
            return {
                ...state,
                resendOTPRequest: false,
                resendOTPSuccess: false,
                resendOTPFailure: true
            }

        default:
            return state
    }
}